import { vxm } from '@/store.vuex';

const RudderAnalytics = require("@rudderstack/analytics-js/dist/npm/legacy/umd/index.js").RudderAnalytics;

export class Rudderstack{
  private static rudderAnalytics: any;
  private static rudderAnalyticsLoaded: Boolean = false;
  //private static readonly rudderStackKey = window.WorkLLama.rudderStackKey;

  public static loadRudderAnalytics(rudderStackKey?:String , rudderStackUrl?: String) { 
    if (this.getIsRudderstackEnabled) { return };
    try {
      this.rudderAnalytics = new RudderAnalytics();
       this.rudderAnalytics.load(rudderStackKey, rudderStackUrl, {
        onLoaded: () => {
           this.rudderAnalyticsLoaded = true;
           this.rudderAnalytics.page();
          console.log('RudderStack JavaScript SDK loaded successfully');
        }
      });
    }
    catch (error) { console.warn("failed to load Rudderstack", error); }
  }
  public trackEvent(eventName: String, dataObject?: Object) {
    if (Rudderstack.getIsRudderstackEnabled) return;
    try {
      if (Rudderstack.rudderAnalyticsLoaded) {
        const navigationInfo = this.getNavigationInfo;
        const stateInfo = this.getStateInfo(dataObject);
        const userInfo = this.getUserInfo(eventName);
        
        const extraParams = {
          version: "1.0.00",
          navigationInfo,
          stateInfo,
          userInfo,
        };
         Rudderstack.rudderAnalytics.track(eventName, extraParams,
          () => { console.log("sending analytics for the event", eventName) });
      } else {
        throw new Error('Rudderstack not loaded properly');
      }
    } catch (error) { 
      console.warn(error.message);
    }
  }
  private get getNavigationInfo() { 

    const navigationInfo = {
     source:document.title.split("|")[0] || document.title ,    
      targetTitle: document.title,      // Source current title (dynamic)
      targetUrl: window.location.href,
    };
    return navigationInfo;
  }

  private getStateInfo(dataObject) {
    const { jobPostingId, jobTitle, jobName, recruiterId, filterParams, shareUrl, referralType, jobAlertId, forumPostId, jobAlertName, jobAlertFrequency } = dataObject;
    const stateInfo = {
      ...(jobPostingId && { jobPostingId }),
      ...(forumPostId && { forumPostId }),
      ...(filterParams && { filterParams }),
      ...(recruiterId && { recruiterId }),
      ...(referralType && { referralType }),
      //...(comments && { comments }),
      ...(shareUrl && { jobShareUrl: shareUrl }),
      ...(jobAlertId && { jobAlertId }),
      ...(jobAlertName && { jobAlertName }),
      ...(jobAlertFrequency && { jobAlertFrequency }),
      ...((jobTitle || jobName) && { jobTitle: jobTitle || jobName }),
      ...dataObject
    };
    return stateInfo;
  }
  private getUserInfo( eventName) {
    const userInfo = {
      eventName,
      eventSourceChannel: "TP web",
      companyCode : vxm.jobs.BrandingInfo.companycode,
      anonUserDistinctID: Rudderstack.rudderAnalytics.getAnonymousId(),
      llamaUserId: vxm.users.myUserProfile.userId,
      isLoggedIn : vxm.users.isLoggedIn
    };
    return userInfo;
  }
 
  private static get getIsRudderstackEnabled(): Boolean
  { return !vxm.configs.getGlobalConfigBooelanValue('ENABLE_WL_ANALYTICS_INTEGRATION'); }
}